import req from 'libs/http'
import Vue from 'vue';
import store from '@/store'
import { getConfig } from 'config'
import util from 'libs/util'
const TOKEN_KEY = 'BBWK_TOKEN';
const BBWK_WX_CODE = 'BBWK_WX_CODE'; // 微信code
const BBWK_OPENID = 'BBWK_OPENID'
const user = {
  getFormatUserInfo(user = {}) {
    const staticUrl = store.getters.getStaticUrl;
    let sex = user.sex;
    if (!user.photo) {
      user.photo = `${staticUrl}/default_head.png?v=2020025`;
    }
    if (user.webUser) {
      user.mobile = user.webUser.userTel
    }
    if (!user.nickName) {
      user.nickName = `用户${user.userId || ''}`;
    }
    return user
  },
  getUserId() {
    return wx.getStorageSync('userId') || '';
  },
  isLogin() {
    return store.state.userInfo.id;
  },
  checkIsLogin(callback, type = 1, isBindCallback = true) {
    if (this.isLogin()) {
      callback && callback(false, store.getters.getUserInfo);
    } else {
      this.goLogin(isBindCallback ? callback : null, type);
    }
  },
  isLoginReady() {
    return new Promise((resolve, reject) => {
      const t = setInterval(() => {
        if (store.getters.getIsCheckLogin) {
          clearInterval(t);
          resolve(store.getters.getUserInfo);
        }
      }, 10)
    })
  },
  async refreshUserInfo(callback) {
    await store.dispatch('queryUserInfo');
    callback && callback(store.getters.getUserInfo);
  },
  goLogin(nextCallback, type) {
    const $router = window.$router;
    const gopage = Vue.prototype.$gopage;
    const currentRoute = $router.currentRoute;
    const query = {};
    if (currentRoute) {
      const redirectURL = currentRoute.fullPath;
      if (nextCallback) {
        Vue.prototype.$nextCallback = {
          type,
          callback: (userInfo) => {
            nextCallback(true, userInfo);
          }
        }
      }
      if (redirectURL.indexOf("redirectURL") < 0) {
        query.redirectURL = encodeURIComponent(redirectURL);
      }
      gopage('login', query)
    }
  },
  loginCallBack(query) {
    let vue_proto = Vue.prototype;
    let redirectURL = query.redirectURL || '/';
    if (redirectURL) {
      redirectURL = decodeURIComponent(redirectURL);
    }
    vue_proto.$gopage(redirectURL, {}, true);
    // console.log(vue_proto.$nextCallback)
    // if (vue_proto.$nextCallback) {
    //   const { type, callback } = vue_proto.$nextCallback;
    //   if (type == 1) { // 页面跳转立即执行
    //     callback && callback(true);
    //   } else if (type == 2) {
    //     Vue.prototype.$gopage(redirectURL, {}, true); // 动作操作，延迟两秒执行
    //     setTimeout(() => {
    //       callback && callback();
    //       this.$nextCallback = null;
    //     }, 2000)
    //   } else {
    //     callback && callback(store.getters.getUserInfo);
    //   }
    // } else {
    //   console.log(';gopage')
    //   vue_proto.$gopage(redirectURL, {}, true);
    // }
  }
}

export default user